import { useMemo, useState, useEffect } from "react"

import socialanxiety from "../assets/socialanxiety.png"
import depression from "../assets/depression.png"
import ptsd from "../assets/ptsd.png"
import stress from "../assets/stress.png"
import panicattack from "../assets/panicattack.png"
import selfesteem from "../assets/selfesteem.png"
import ocd from "../assets/ocd.png"
import healthanexity from "../assets/healthanexity.png"

import phobias from "../assets/phobias.png"
import lgbqttherapy from "../assets/lgbqttherapy.png"
import psychosexualtherap from "../assets/psychosexualtherap.png"
import relationshipcounselling from "../assets/relationshipcounselling.png"

const therapies = [
  
  {
    title: "LGBTQ Therapy",
    desc: "Affirmative and inclusive therapeutic support",
    more:
      "Therapy can offer an affirming space to explore identity, relationships, family dynamics, or stress related to discrimination. Support is led by what matters to you.",
    img: lgbqttherapy,
  },
  
  {
    title: "OCD",
    desc: "Support for intrusive thoughts and compulsions",
    more:
      "OCD can involve unwanted intrusive thoughts and urges to do compulsions for relief. Therapy can help you understand the cycle and develop ways to respond differently over time.",
    img: ocd,
  },
  {
    title: "Depression",
    desc: "Recovery focused care",
    more:
      "Depression can affect mood, energy, sleep, and motivation. Therapy can help you understand patterns, build coping tools, and take small steady steps toward feeling more like yourself.",
    img: depression,
  },
  {
    title: "Stress",
    desc: "Tools for everyday pressures",
    more:
      "Stress can build up from work, relationships, or life changes. Therapy can support you with grounding tools, boundaries, and practical strategies to reduce overwhelm.",
    img: stress,
  },
  {
    title: "Panic Attacks",
    desc: "Managing sudden and overwhelming anxiety",
    more:
      "Panic attacks can feel frightening and unpredictable. Therapy can help you understand triggers, reduce fear of symptoms, and practice techniques that bring the body back to calm.",
    img: panicattack,
  },
  {
    title: "Soical Anxiety",
    desc: "Support and practical strategies",
    more:
      "Social anxiety can make everyday interactions feel intense. Therapy can help reduce self conscious thoughts, build confidence, and support you to feel more comfortable around others.",
    img: socialanxiety,
  },
  {
    title: "PTSD",
    desc: "Safe paced therapeutic approach",
    more:
      "PTSD can involve flashbacks, hypervigilance, or feeling emotionally numb. Therapy can offer a safe paced space to process experiences and rebuild a sense of safety and control.",
    img: ptsd,
  },
  {
    title: "Self Esteem",
    desc: "Developing self worth and confidence",
    more:
      "Low self esteem can impact relationships, work, and how you see yourself. Therapy can help challenge harsh self talk and build a more supportive inner voice.",
    img: selfesteem,
  },
  {
    title: "Health Anxiety",
    desc: "Reducing fear around health and symptoms",
    more:
      "Health anxiety can keep you stuck in reassurance seeking and scanning for symptoms. Therapy can help reduce the fear cycle and build trust in your body again.",
    img: healthanexity,
  },
  {
    title: "Relationship Counselling",
    desc: "Support for communication and connection",
    more:
      "Relationship counselling can help you improve communication, rebuild trust, and understand patterns that keep you feeling disconnected. This can be for couples or individuals.",
    img: relationshipcounselling,
  },
  {
    title: "Phobias",
    desc: "Gradual support to face specific fears",
    more:
      "Phobias can feel limiting and exhausting. Therapy can support gradual safe steps to face fears and reduce the intensity of the response over time.",
    img: phobias,
  },
  {
    title: "Psychosexual Issues",
    desc: "Exploring intimacy and sexual wellbeing",
    more:
      "Psychosexual therapy can support concerns around desire, intimacy, confidence, or sexual difficulties. Sessions focus on understanding, reducing shame, and improving wellbeing.",
    img: psychosexualtherap,
  },
]

function getInitialVisibleCount() {
  if (typeof window === "undefined") return 4
  const w = window.innerWidth

  if (w >= 1200) return 8
  if (w >= 992) return 6
  if (w >= 768) return 4
  return 2
}

export default function AreasOfSupport() {
  const [showAll, setShowAll] = useState(false)
  const [visibleCount, setVisibleCount] = useState(getInitialVisibleCount)
  const [openTitle, setOpenTitle] = useState(null)

  const visibleTherapies = useMemo(() => {
    if (showAll) return therapies
    return therapies.slice(0, visibleCount)
  }, [showAll, visibleCount])

  useEffect(() => {
    if (typeof window === "undefined") return

    const onResize = () => {
      const next = getInitialVisibleCount()
      setVisibleCount(next)
    }

    window.addEventListener("resize", onResize)
    return () => window.removeEventListener("resize", onResize)
  }, [])

  const hiddenCount = therapies.length - visibleCount

  const toggleOpen = (title) => {
    setOpenTitle((curr) => (curr === title ? null : title))
  }

  return (
    <section id="areasofsupport" className="py-5 section-tint">
      <div className="py-4 main-wrap">
        <div className="text-center mb-4">
          <h2 className="h1 fw-semibold mb-2">Areas Supported</h2>
          <p className="text-secondary mb-0">What you can get help with</p>
        </div>

        <div className="row g-4 justify-content-center mb-4">
          {visibleTherapies.map((t) => {
            const isOpen = openTitle === t.title
            const collapseId = `support-${t.title.replace(/\s+/g, "").toLowerCase()}`

            return (
              <div key={t.title} className="col-12 col-md-6 col-lg-4 col-xl-3">
                <div className="card h-100 shadow-sm border-0 rounded-4 overflow-hidden">
                  <img
                    className="card-img-top location-img"
                    src={t.img}
                    alt={t.title}
                    loading="lazy"
                  />

                  <div className="card-body d-flex flex-column text-center p-4">
                    <h3 className="h5 fw-semibold mb-1">{t.title}</h3>
                    <p className="text-secondary mb-3">{t.desc}</p>

                    <div
                      id={collapseId}
                      className={`collapse ${isOpen ? "show" : ""}`}
                    >
                      <p className="text-secondary mb-3">{t.more}</p>
                    </div>

                    <button
                      type="button"
                      className="btn btn-outline-brand fw-semibold mt-auto"
                      aria-expanded={isOpen}
                      aria-controls={collapseId}
                      onClick={() => toggleOpen(t.title)}
                    >
                      {isOpen ? "Hide details" : "View details"}
                    </button>
                  </div>
                </div>
              </div>
            )
          })}
        </div>

        {therapies.length > visibleCount && (
          <div className="text-center mb-4">
            {!showAll ? (
              <button
                type="button"
                className="btn btn-outline-brand fw-semibold"
                onClick={() => setShowAll(true)}
              >
                Show all {hiddenCount > 0 ? `(${hiddenCount})` : ""}
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-outline-brand fw-semibold"
                onClick={() => setShowAll(false)}
              >
                Show less
              </button>
            )}
          </div>
        )}

        <div className="text-center">
          <p className="text-secondary mb-0">
            Whether you are feeling overwhelmed, stuck, or struggling with difficult experiences, support is available.
            Therapy offers space to explore what you are going through and develop practical ways to move forward at a
            pace that feels right for you.
          </p>
        </div>
      </div>
    </section>
  )
}
